const AdminWallet = () => {
    return(
        <>
        wallet
        </>
    )
};
export default AdminWallet;